import api from '@/api.js';
const state = {
    ticketSets: [],
    items: [],
    draw: {},
    sim: {},
    predicts: [],
    forecast: {},
    tests: [],
    test: {}
};
// Hilfsfunktion: zählt Schnittmenge zweier SORTIERTER Felder in O(6)
function countOverlapSorted(a, b) {
    let i = 0, j = 0, k = 0;
    while (i < a.length && j < b.length) {
        if (a[i] === b[j]) {
            k++;
            i++;
            j++;
        }
        else if (a[i] < b[j])
            i++;
        else
            j++;
    }
    return k;
}
// Gewichtung für Overlap (du kannst die Zahlen feinjustieren)
function overlapWeight(k) {
    switch (k) {
        case 6: return 1000; // identisch → sehr hohe Strafe
        case 5: return 200;
        case 4: return 40;
        case 3: return 8;
        case 2: return 3;
        case 1: return 1;
        default: return 0;
    }
}
// Overlap-Penalty über das gesamte TicketSet
function calcOverlapPenalty(ticketSet) {
    // Alle Felder einsammeln und sortieren (für schnellen Overlap)
    const fields = [];
    for (const t of ticketSet.tickets) {
        for (const f of t.fields)
            fields.push([...f].sort((a, b) => a - b));
    }
    // Optional: exakte Duplikate schnell hart bestrafen
    let penalty = 0;
    const seen = new Map();
    for (const f of fields) {
        const key = f.join(',');
        seen.set(key, (seen.get(key) ?? 0) + 1);
    }
    for (const [, cnt] of seen) {
        if (cnt > 1)
            penalty += (cnt - 1) * 1000; // jede zusätzliche Kopie teuer
    }
    // Paarweise Overlap (j = i+1 → kein Selbstvergleich, keine Doppelzählung)
    for (let i = 0; i < fields.length; i++) {
        for (let j = i + 1; j < fields.length; j++) {
            const k = countOverlapSorted(fields[i], fields[j]);
            penalty += overlapWeight(k);
        }
    }
    return penalty;
}
function setQuality(ticketSet) {
    // counts / uniqueCount hast du bereits
    const allNums = [];
    const counts = {};
    for (const ts of ticketSet.tickets) {
        for (const f of ts.fields) {
            for (const n of f) {
                allNums.push(n);
                counts[n] = (counts[n] || 0) + 1;
            }
        }
    }
    const maxStdDev = 5;
    const maxPenalty = 8000;
    // Verteilungs-Glättung (STD der Häufigkeiten)
    const freqs = Object.values(counts);
    const mean = freqs.reduce((a, b) => a + b, 0) / freqs.length;
    const variance = freqs.reduce((s, v) => s + (v - mean) ** 2, 0) / freqs.length;
    const stdDev = Math.sqrt(variance);
    const overlapPenalty = calcOverlapPenalty(ticketSet);
    const diversityScore = Object.keys(counts).length / 49;
    const spreadScore = stdDev / maxStdDev;
    const overlapScore = overlapPenalty / maxPenalty;
    // Gewichte anpassen nach Geschmack
    const W1 = 10, W2 = 10, W3 = 10;
    const quality = diversityScore * W1 + spreadScore * W2 - overlapScore * W3;
    return { quality, diversityScore, spreadScore, overlapScore, stdDev, overlapPenalty };
}
const mutations = {
    set_tickets(state, sets) {
        sets.forEach(s => {
            s.quality = setQuality(s);
            console.log('quality', s.quality);
        });
        state.ticketSets = sets;
    },
    set_items(state, items) {
        state.items = items;
    },
    // list(state, items) {
    //     state.items = items;
    // },
    set_forecast(state, forecast) {
        state.forecast = forecast;
    },
    drawing(state, draw) {
        state.draw = draw;
    },
    sim(state, sim) {
        state.sim = sim;
    },
    set_predicts(state, predicts) {
        state.predicts = predicts;
    },
    set_tests(state, tests) {
        state.tests = tests;
    },
    set_test(state, test) {
        state.test = test;
    }
};
const getters = {
    sets: (state) => state.ticketSets,
    items: (state) => state.items,
    draw: state => state.draw,
    simulated: state => state.sim,
    predicts: state => state.predicts,
    forecast: state => state.forecast,
    tests: state => state.tests,
    test: state => state.test
};
const actions = {
    // async list({ commit }) {
    //     const res = await api.tools.lotto();
    //     commit('list', res.data);
    // },
    async load({ commit }) {
        const res = await api.lotto.load();
        commit('set_items', res.data);
    },
    async loadSets({ commit }) {
        const sets = await api.lotto.tickets();
        commit('set_tickets', sets.data);
    },
    async drawing({ commit }, date) {
        console.log('DRAWING', date);
        const dayOfWeek = date.getDay(); // 0 = Sonntag, 1 = Montag, ..., 6 = Samstag
        // Ziehungstage: 3 = Mittwoch, 6 = Samstag
        const DRAWING_DAYS = [3, 6];
        // Suche den letzten Ziehungstag vor oder an diesem Datum
        let daysToSubtract = 0;
        if (dayOfWeek >= 6) {
            // Samstag oder später: letzte Ziehung war an diesem Samstag
            daysToSubtract = dayOfWeek - 6;
        }
        else if (dayOfWeek >= 3) {
            // Mittwoch oder später: letzte Ziehung war an diesem Mittwoch
            daysToSubtract = dayOfWeek - 3;
        }
        else {
            // Vor Mittwoch: letzte Ziehung war der Samstag davor
            daysToSubtract = dayOfWeek + 1; // +1, weil Samstag = 6
        }
        // Ziehungstag berechnen
        const drawingDate = new Date(date);
        drawingDate.setDate(date.getDate() - daysToSubtract);
        // Unix-Timestamp in Millisekunden
        const ut = drawingDate.getTime();
        console.log('ut=', ut);
        const resp = await api.lotto.drawing(ut);
        console.log('response:', resp.data);
        commit('drawing', (resp.data.length && resp.data[0]) || []);
    },
    async simulation({ commit }, cfg) {
        console.log('vuex.cfg', cfg);
        const resp = await api.lotto.simulation(cfg);
        commit('sim', resp.data);
    },
    async load_predicts({ commit }) {
        const resp = await api.lotto.predicts();
        commit('set_predicts', resp.data);
    },
    async get_forecast({ commit }, cfg) {
        console.log('get foracst', cfg);
        const resp = await api.lotto.forecast(cfg.date, cfg.tickets, cfg.draws, cfg.strategy);
        commit('set_forecast', resp.data);
    },
    async get_tests({ commit }) {
        const resp = await api.lotto.tests();
        commit('set_tests', resp.data);
    },
    async get_test({ commit }, name) {
        const resp = await api.lotto.test(name);
        commit('set_test', resp.data);
    }
};
export const Lotto = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
